// extracted by css-extract-rspack-plugin
export default {"root":"Vk9WehoTb-kgKImgTgqrG"};